<template>
    <tr>
        <td>
            <a
                :href="baseDocumentUrl"
                :title="documentTitle"
                class="long-and-truncated"
                target="_blank"
            >
                {{ documentTitle }}
            </a>
        </td>
        <td>
            <i :title="authorTitle + postedAt" class="fas fa-info"></i>
        </td>
        <td>
            <a
                @click.prevent="showConfirmDeletionModal"
                :title="trans.blog.manage.delete_post_from_blog_title"
            >
                <i class="fas fa-trash-alt"></i>
            </a>
        </td>
    </tr>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "BaseBlogPostTableRow",
    props: ['post'],
    computed: {
        ...mapGetters('baseBlogManager', [
            'trans',
        ]),
        authorTitle() {
            return this.post.author.name + ' (' + this.post.author.email + ') ';
        },
        postedAt() {
            return this.trans.blog.manage.posted_at_title + this._dateTimeFormat(this.post.created_at);
        },
        documentTitle() {
            return this.post.document_title;
        },
        baseDocumentUrl() {
            return this.replaceWildcards(actions.publicLink, { document_hash: this.post.base_document_hash_id });
        },
    },
    methods: {
        ...mapActions('baseBlogManager', [
            'showBaseBlogDeleteExistingPostModal',
            'setPostHashToDelete',
            'hideBaseBlogMainModal',
            'saveModalWindowState',
        ]),
        showConfirmDeletionModal() {
            this.setPostHashToDelete(this.post.blog_post_hash_id);
            this.saveModalWindowState();
            this.hideBaseBlogMainModal();
            this.showBaseBlogDeleteExistingPostModal();
        },
    },
}
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables.scss';

    .long-and-truncated {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .fas {
        opacity: 0.2;
        color: $black;
        &:hover {
            opacity: 0.8;
        }
    }

    a {
        width: 450px;
        overflow:hidden;
        white-space:nowrap;
        display:inline-block;
    }

    .bulma .table td {
        border: none;
    }
</style>
